/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = true,
    styles = {
      success: "background: darkgreen; color: white; padding: 2px 6px; border-radius: 3px",
      error: "background: darkred; color: white; padding: 2px 6px; border-radius: 3px",
      warning: "background: darkorange; color: white; padding: 2px 6px; border-radius: 3px",
      info: "background: blue; color: white; padding: 2px 6px; border-radius: 3px"
    };

  function log(...args) { DEBUG && console.log(...args); }
  function collapse(type, data, title = "Log", status = "info") {
    if (!DEBUG) return;
    console.groupCollapsed(`%c ${title}`, styles[status] || styles.info),
      type === "table" ? console.table(data) : console.log(data),
      console.groupEnd();
  }
  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);


/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== 'desktop') {
        // Switch to desktop view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy mobile Slick if initialized
        if (desktopOptions) carousel.slick(desktopOptions); // Initialize with desktop options
        currentView = 'desktop';
      }
    } else {
      if (currentView !== 'mobile') {
        // Switch to mobile view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy desktop Slick if initialized
        carousel.slick(mobileOptions); // Initialize with mobile options
        currentView = 'mobile';
      }
    }
  }

  initializeCarousel();
  $(window).on('resize', function () {
    initializeCarousel();
  });
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}


$(document).ready(function () {
  $('.qz_revs_carousel').slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    arrows: true,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      }
    ]
  });
  $('.qz_rn_next').click(function () {
    $('.qz_revs_carousel').find('.slick-next').trigger('click');
  });
  $('.qz_rn_prev').click(function () {
    $('.qz_revs_carousel').find('.slick-prev').trigger('click');
  });

  if ($('.qz_reviews_carousel').length) {
    $('.qz_reviews_carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '60px',
      dots: false,
      arrows: false,
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: true,
          centerPadding: '20px'
        }
      }]
    });
  }


  const $button = $('.ScrollToProduct');

  $button.on('click', function (e) {
    e.preventDefault();
    const $scrollTo = $('product-form.product-form').length ? $('product-form.product-form') : $('.product-main');
    const offsetTop = $scrollTo.offset().top - 160;
    $('html, body').animate({ scrollTop: offsetTop }, 600);
  });

  function checkButtonVisibility() {
    // Only check visibility on mobile screens
    if ($(window).width() <= 768) {
      const $scrollTo = $('product-form.product-form').length ? $('product-form.product-form') : $('.product-main');
      if ($scrollTo.length) {
        const elementTop = $scrollTo.offset().top;
        const elementBottom = elementTop + $scrollTo.outerHeight();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        // Show button if element is not in viewport
        $button.toggleClass('hidden', elementTop >= viewportTop && elementBottom <= viewportBottom);
      }
    } else {
      // Always show on desktop
      $button.removeClass('hidden');
    }
  }

  // Check on both load, scroll, and resize
  $(window).on('load scroll resize', checkButtonVisibility);

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});